<template>
  <section class="content">
    <div class="box box-info">
      <div class="p-toolbar p-component mb-4">
        <itemGroupDialog ref="itemGroupdialog"/>
        </div>
        <itemgrouplist @delete-message="deleteMessage" @edit-group="editItemGroup"/>
      </div>
  </section>
</template>
<script>
import itemgrouplist from './itemgrouplist.vue'
import itemGroupDialog from '../itemDialog/itemGroupDialog.vue'
export default {
  name: 'itemgroup',
  data() {
    return {
    }
  },
  methods: {
    editItemGroup(data) {
      this.$refs.itemGroupdialog.editItemGroup(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    itemgrouplist,
    itemGroupDialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// Itemgroup.vue?1b5c439e